import * as actions from './rel-save.actions';
import * as ctrlsConstants from 'src/app/shared/_config/ctrls/ctrls-constants';

import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Injectable, inject } from '@angular/core';
import { SpxStorage, SpxStorageKeyEnum } from '@softpak/components/spx-storage';
import { SpxToasterAutoCloseSpeedEnum, spxToasterActions } from '@softpak/components/spx-toaster';
import { catchError, exhaustMap, map, mergeMap } from 'rxjs/operators';

import { ApiRelMethod } from 'src/app/api/api-methods.rel';
import { Observable } from 'rxjs';
import { RelSaveResponseI } from '../../api/rel-save/rel-save.query.result.int';
import { SharedErrorObjectI } from 'src/app/shared/models/shared/shared-error-object.interface';
import { SharedGenericService } from 'src/app/shared/services/shared-generic.service';
import { SharedPageTypeEnum } from 'src/app/shared/navigation/page-type.enum';
import { Store } from '@ngrx/store';
import { loadingRelSave } from 'src/app/shared/_config/i18n/i18n-interface';
import { spxSpinnerActions } from '@softpak/components/spx-spinner';
import { statsActionActions } from '../stats-action';

@Injectable()
export class RelSaveEffects {
    private readonly appStore$ = inject(Store);
    private readonly actions$ = inject(Actions);
    private readonly sharedGenericService = inject(SharedGenericService);


    load$ = createEffect(() =>
        this.actions$.pipe(ofType(actions.load),
            exhaustMap((params) => this.sharedGenericService.invoke(ApiRelMethod.relSave, {
                [ctrlsConstants.ctrlSequenceNumber]: params.query.seqNr,
                [ctrlsConstants.ctrlNewLocation]: params.query.newLocation,
            }).pipe(
                map((data: RelSaveResponseI) => actions.received({
                    data,
                    pageType: params.pageType,
                })),
                catchError((error: SharedErrorObjectI) => [
                    actions.error({
                        messageText: error.message,
                        pageType: params.pageType,
                    }),
                ])
            ))
        ));

    onError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(action => [
            spxToasterActions.createError({
                autoClose: SpxToasterAutoCloseSpeedEnum.DEFAULT,
                messageText: action.messageText,
            }),
        ]))
    );

    afterReceived$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.received),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingRelSave
            }),
        ])
        )
    );

    afterLoad$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(() => [
            spxSpinnerActions.show({
                action: loadingRelSave
            }),
        ]))
    );

    afterLoadStats$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.load),
        mergeMap(({ pageType, query }) => [
            this.createStatsAction(
                pageType === SharedPageTypeEnum.ordAutomaticShuffle
                    ? 'AMQ_SHUFFLE'
                    : 'STANDARD_RELOCATE_SUBMIT',
                query.seqNr
            )
        ])
    ));

    afterError$: Observable<any> = createEffect(() => this.actions$.pipe(
        ofType(actions.error),
        mergeMap(() => [
            spxSpinnerActions.hide({
                action: loadingRelSave
            }),
        ]))
    );

    private createStatsAction(action: string, containerSequenceNumber?: number | null) {
        return statsActionActions.load({
            query: {
                app: 'orders',
                customer: SpxStorage.getSetting(SpxStorageKeyEnum.brand),
                action,
                actionData: containerSequenceNumber == null ? undefined : { containerSequenceNumber },
                randomDeviceId: SpxStorage.getSetting(SpxStorageKeyEnum.randomDeviceId),
                username: SpxStorage.getSetting(SpxStorageKeyEnum.username),
            },
        });
    }
}
